module.exports = __webpack_public_path__ + "static/media/unblock.709bdca5.svg";